import { usePostMessage } from '../../../context/messageContext';
import { CameraMethodView } from '../../session/calibration/ClinicianCalibrationViews';

// Camera calibration method: IBIS-Tool (C4.1) or Blindspot. Same ws messages as before.
const CameraCalibrationSelection = ({ setStep }) => {
  const postMessage = usePostMessage();

  const selectCalibrationType = (selection) => {
    postMessage({ type: selection });
    return setStep(selection);
  };

  const previousStep = () => {
    postMessage({ type: 'holding' });
    setStep('calibration-selection');
  };

  return <CameraMethodView onSelect={selectCalibrationType} onBack={previousStep} />;
};

export default CameraCalibrationSelection;
